import { api } from "./axios.config";
import axios from "./axios";

const API_URL = api.apiUrl;
const EVENT_URL = "/event/";
const LINKEDIN_URL = "/linkedin/";

// https://api.konfhub.com/event/:event-id/linkedin/post-setup
export const getLinkedInShareData = (eventId) => {
    return axios.get(API_URL + EVENT_URL + eventId + LINKEDIN_URL + "post-setup");
};

// https://api.konfhub.com/event/:event-id/linkedin/post-setup
export const updateLinkedInShareData = (eventId, payload) => {
    return axios.put(API_URL + EVENT_URL + eventId + LINKEDIN_URL + "post-setup", payload);
};

// https://api.konfhub.com/event/:event-id/linkedin/app-setup
export const getLinkedInClientData = (eventId) => {
    return axios.get(API_URL + EVENT_URL + eventId + LINKEDIN_URL + "app-setup");
};

// https://api.konfhub.com/event/:event-id/linkedin/app-setup
export const updateLinkedInClientData = (eventId, payload) => {
    return axios.put(API_URL + EVENT_URL + eventId + LINKEDIN_URL + "app-setup", payload);
};